import { useState, useEffect, useRef } from 'react'
import RealEstatePageLayout from '../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import * as yup from "yup";
import { Formik, useFormik } from 'formik';
import Swal from 'sweetalert2'
import axios from "axios";
import { useTranslation } from "react-i18next";
import PhoneInputField from '../components/PhoneInputField'
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';

const validationSchema = yup.object({
  fullname: yup.string().required("Veuillez renseigner votre prénom et nom."),
  email: yup.string().email("Veuillez renseigner votre adresse email valide.").required("Veuillez renseigner votre adresse email."),
  // phone_number: yup.string().required("Veuillez renseigner votre numéro de téléphone."),
  phone_number: yup.string()
    .required("le numéro de téléphone est obligatoire")
    .test('is-valid-phone', 'Numéro de téléphone invalide', function (value) {
      if (!value) return false;
      try {
        const phoneUtil = PhoneNumberUtil.getInstance();
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    }),
  id_subject: yup.string().required("Veuillez choisir le sujet."),
  message: yup.string().required("Veuillez renseigner votre message."),
});
const ContactsPage = () => {
  const { t } = useTranslation('common');

  const formik = useFormik({
    initialValues: {
      fullname: '',
      id_subject: '1',
      phone_number: '',
      email: '',
      message: '',
    },
    validationSchema,
    onSubmit: values => {
      const formData = new FormData();
      Object.keys(values).map(key => {
        formData.append(key, values[key]);
      });

      axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/leads/contact-us`, formData).then(function (response) {
        formik.resetForm();
        Swal.fire({
          text: "L'équipe Facilykey vous contactera après avoir examiné votre formulaire",
          icon: "success",
          buttonsStyling: !1,
          confirmButtonText: "Ok, Merci!",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        });
      })
        .catch(function (error) {
          console.error(error);
        });
    },
  });


  const animationContainer = useRef(null)

  useEffect(() => {
    let animation
    let cancelled = false

    // lottie touches `document` at import time, so load it client-side only
    import('lottie-web/build/player/lottie_light').then(({ default: lottie }) => {
      if (cancelled || !animationContainer.current) return
      animation = lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/animation/contact.json'
      })
    })

    return () => {
      cancelled = true
      animation?.destroy()
    }
  }, [])

  return (
    <RealEstatePageLayout
      pageTitle={t("Contactez-nous")}
      description={t("Contactez Facilykey par téléphone, e-mail ou formulaire pour acheter, vendre, louer ou estimer votre bien immobilier au Maroc.")}
      activeNav='Pages'
    >
      {/* Breadcrumbs */}
      <Container className='mt-5 mb-md-4 pt-5'>
        <Breadcrumb className='mb-3 pt-md-3'>
          <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
          <Breadcrumb.Item active>{t("Contactez-nous")}</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      {/* Hero */}
      <Container as='section' className='mb-5 pb-2 pb-md-4 pb-lg-5'>
        <Row className='gy-4 align-items-md-start align-items-center'>
          <Col xs={12} md={6} lg={5}>
            <div className='mx-md-0 mx-auto mb-md-5 mb-4 pb-md-4 text-md-start text-center' style={{ maxWidth: '416px' }}>
              <h1 className='mb-4'>{t("Nous sommes là pour vous aider.")}</h1>
              <p className='mb-0 fs-lg text-muted'>{t("Nos services se tiennent à votre disposition pour vous répondre.")}</p>
            </div>
            <div className='text-center'>
              <div ref={animationContainer}></div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={{ offset: 1 }}>
            {/* Contact form */}
            <Card className='border-0 bg-secondary p-sm-3 p-2'>
              <Card.Body className='m-1'>
                <Form
                  noValidate
                  onSubmit={formik.handleSubmit}
                >
                  <Form.Group controlId='c-name' className='mb-4'>
                    <Form.Label>{t("Votre prénom et nom")}</Form.Label>
                    <Form.Control size='lg'
                      onChange={formik.handleChange('fullname')}
                      onBlur={formik.handleBlur('fullname')}
                      isValid={formik.touched.fullname && !Boolean(formik.errors.fullname)}
                      isInvalid={formik.touched.fullname && Boolean(formik.errors.fullname)}
                      value={formik.values.fullname}
                      required />
                    {formik.errors.fullname && formik.touched.fullname ? <Form.Control.Feedback type='invalid'>{t(formik.errors.fullname)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group controlId='c-email' className='mb-4'>
                    <Form.Label>{t("Votre email")}</Form.Label>
                    <Form.Control size='lg' type='email'
                      onChange={formik.handleChange('email')}
                      onBlur={formik.handleBlur('email')}
                      isValid={formik.touched.email && !Boolean(formik.errors.email)}
                      isInvalid={formik.touched.email && Boolean(formik.errors.email)}
                      value={formik.values.email}
                      required />
                    {formik.errors.email && formik.touched.email ? <Form.Control.Feedback type='invalid'>{t(formik.errors.email)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group controlId='ab-phone' className='mb-4'>

                    <Form.Label>{t("Numéro de téléphone")} <span className='text-danger'>*</span></Form.Label>
                    <PhoneInputField formik={formik} />
                  </Form.Group>
                  <Form.Group controlId='c-service' className='mb-4'>
                    <Form.Label>{t("Sujet")}</Form.Label>
                    <Form.Select defaultValue={formik.values.id_subject} required
                      onChange={formik.handleChange('id_subject')}
                      onBlur={formik.handleBlur('id_subject')}
                      isValid={formik.touched.id_subject && !Boolean(formik.errors.id_subject)}
                      isInvalid={formik.touched.id_subject && Boolean(formik.errors.id_subject)}>
                      <option value='default' disabled>{t("Choisissez le sujet")}</option>
                      <option value='1'>{t("Demande de renseignements sur une propriété")}</option>
                      <option value='2'>{t("Demande de partenariat immobilier")}</option>
                      <option value='3'>{t("Demande de consultation immobilière")}</option>
                      <option value='4'>{t("Vendre votre bien")}</option>
                      <option value='5'>{t("Plainte")}</option>
                    </Form.Select>
                    {formik.errors.id_subject && formik.touched.id_subject ? <Form.Control.Feedback type='invalid'>{t(formik.errors.id_subject)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <Form.Group controlId='c-message' className='mb-4'>
                    <Form.Label>{t("Message")}</Form.Label>
                    <Form.Control size='lg' as='textarea' rows='4'
                      onChange={formik.handleChange('message')}
                      onBlur={formik.handleBlur('message')}
                      isValid={formik.touched.message && !Boolean(formik.errors.message)}
                      isInvalid={formik.touched.message && Boolean(formik.errors.message)}
                      value={formik.values.message}
                      placeholder={t('Laissez votre message')}
                      required />
                    {formik.errors.message && formik.touched.message ? <Form.Control.Feedback type='invalid'>{t(formik.errors.message)}</Form.Control.Feedback> : null}
                  </Form.Group>
                  <div className='pt-2'>
                    <Button type='submit' size='lg' variant='primary' className='w-sm-auto w-100'>{t("Envoyer")}</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Contact cards */}
      <Container as='section' className='mb-5 pb-2 pb-md-4 pb-lg-5'>
        <Row xs={1} md={3} className='g-4'>
          {/*<Col>*/}
          {/*  <Card as='a' href='#' className='icon-box card-hover h-100'>*/}
          {/*    <Card.Body>*/}
          {/*      <div className='icon-box-media text-primary rounded-circle shadow-sm mb-3'>*/}
          {/*        <i className='fi-help'></i>*/}
          {/*      </div>*/}
          {/*      <span className='d-block mb-1 text-body'>Trouvez des réponses</span>*/}
          {/*      <h3 className='h4 icon-box-title mb-0 opacity-90'>Consulter la FAQ</h3>*/}
          {/*    </Card.Body>*/}
          {/*  </Card>*/}
          {/*</Col>*/}
          <Col>
            <Card as='a' href='https://web.facebook.com/profile.php?id=100094181588390' target={'_blank'} className='icon-box card-hover h-100'>
              <Card.Body>
                <div className='icon-box-media text-primary rounded-circle shadow-sm mb-3'>
                  <i className='fi-facebook'></i>
                </div>
                <span className='d-block mb-1 text-body'>{t("Suivez-nous sur Facebook")}</span>
                <h3 className='h4 icon-box-title mb-0 opacity-90'>@facilykey</h3>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card as='a' href='https://www.instagram.com/facilykey.official' target={'_blank'} className='icon-box card-hover h-100'>
              <Card.Body>
                <div className='icon-box-media text-primary rounded-circle shadow-sm mb-3'>
                  <i className='fi-instagram'></i>
                </div>
                <span className='d-block mb-1 text-body'>{t("Suivez-nous sur Instagram")}</span>
                <h3 className='h4 icon-box-title mb-0 opacity-90'>@facilykey</h3>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card as='a' href='tel:+212615348229' target={'_blank'} className='icon-box card-hover h-100'>
              <Card.Body>
                <div className='icon-box-media text-primary rounded-circle shadow-sm mb-3'>
                  <i className='fi-phone'></i>
                </div>
                <span className='d-block mb-1 text-body'>{t("Appelez-nous")}</span>
                <h3 className='h4 icon-box-title mb-0 opacity-90'>+212 6 15 34 82 29</h3>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </RealEstatePageLayout>
  )
}

export default ContactsPage
